import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios';
import CurrencyInput from '../../../../helpers/CurrencyInput';
import MultiTagInput from '../../component/MultiTagInput/MultiTagInput';
import { getToken } from '../../../../helpers/Jwt';
import { confirmModal } from '../../../../helpers/PromptUtils';
import InputOption from '../../component/InputOption/InputOption';
import FormatTransaction from '../../component/FormatTransaction/FormatTransaction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears } from '@fortawesome/free-solid-svg-icons';

export default function TransferCashBank() {
  const { id,  type } = useParams();

  const [error, setError] = useState(null);
  const [cashbank, setCashBank] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const [isFormatTransactionOpen, setFormatTransactionOpen] = useState(false);


  // Formik initial values
  const initialValues = {};

  // Validation schema (using Yup)
  const validationSchema = Yup.object({
    // description: Yup.string().required('Deskripsi diperlukan'),
    // amount: Yup.number().required('Jumlah diperlukan').positive('Jumlah harus lebih besar dari nol'),
  });

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_ACCOUNT_CASH_BANK = "api/erpppsu/account/cashbank";
  const PATH_TRANSACTION = "api/erpppsu/cashbank/transfer";

  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_ACCOUNT_CASH_BANK}`,).then((data) => {
      setCashBank(data);
    });
  }, []);

  const handleTagsChange = (tags) => {
    setSelectedTags(tags);
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      console.log(values);

      const payload = {
        ...values,
        type: 'transfer',
        selectedTags
      };

      const response = await axios.post(`${BASE_URL}${PATH_TRANSACTION}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      });

      const confirmed = confirmModal(response.data);
      if (confirmed) {
        window.location.reload();
      }
    } catch (error) {
      alert(error.response.data);

    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto p-4">
      <div className='flex items-center justify-between p-5'>
        <h2 className="text-2xl font-bold mb-4">
          Transfer Uang
        </h2>

        <div className='flex items-center'>

        </div>
      </div>

      {/* Formik Form */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            <div className="container m-auto p-4">
              <div className="container m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

                <div className="p-3">
                  <label htmlFor="source_cashbank" className="mb-1 text-sm font-semibold">Transfer Dari</label>
                  <InputOption
                    label="Pilih Data"
                    data={cashbank}
                    placeholder="Ketik disini"
                    onChange={(value) => {
                      setFieldValue(`source_cashbank`, value);
                    }} />  
                </div>

                <div className="p-3">
                  <label htmlFor="target_cashbank" className="mb-1 text-sm font-semibold">Setor Ke</label>
                  <InputOption
                    label="Pilih Data"
                    data={cashbank}
                    placeholder="Ketik disini"
                    onChange={(value) => {
                      setFieldValue(`target_cashbank`, value);
                    }} />                    
                </div>

                <div className="p-3">
                  <label htmlFor="amount" className="mb-1 text-sm font-semibold">Jumlah</label>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    currency="IDR"
                    placeholder="Masukkan Nominal"
                    className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    onChange={(value) => setFieldValue('amount', value)}
                  />
                </div>

                <div></div>

                <div className="p-3">
                  <label htmlFor="memo" className="mb-1 text-sm font-semibold">Memo</label>
                  <Field
                    as="textarea"
                    name="memo"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="memo" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                <MultiTagInput name="tags" options={['Sales', 'PPSU', 'PRSU', 'KMPSUMUT', 'TIKET']} onTagsChange={handleTagsChange} />
                </div>

                <div className="p-3">
                  <FormatTransaction
                    show={isFormatTransactionOpen}
                    onClose={() => setFormatTransactionOpen(false)}
                    apply={(value) => {
                      setFieldValue('no_transaction', value);
                    }} />
                  <label htmlFor="no_transaction" className="mb-1 text-sm font-semibold">
                    No. Transaksi &nbsp;
                    <button type="button" onClick={() => setFormatTransactionOpen(true)}>
                      <FontAwesomeIcon icon={faGears} />
                    </button>
                  </label>
                  <Field
                    name="no_transaction"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="no_transaction" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                  <label htmlFor="date" className="mb-1 text-sm font-semibold">Tgl. Transaksi</label>
                  <Field
                    type='date'
                    name="date"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="date" component="p" className="text-red-500 text-xs mt-1" />
                </div>
              </div>

              <div className="flex items-center justify-end mt-5">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                >
                  {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div >
  )
}
